import { HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';

import { PreMedicoService } from '@/core/api/sicom-api/servicos/pessoa-fisica/pre-medico/pre-medico.service';
import { ServicoAnexoService } from '@/core/api/sicom-api/servicos/shared/servico-anexo.service';
import type { PreMedicoDTO, PreMedicoRequest, PreMedicoResponse } from '@/core/api/sicom-api/servicos/pessoa-fisica/pre-medico/pre-medico.model';

@Injectable({ providedIn: 'root' })
export class PreMedicoServicosService {
    constructor(
        private api: PreMedicoService,
        private servicoAnexo: ServicoAnexoService
    ) {}

    consultar(params: PreMedicoRequest, context?: HttpContext): Observable<PreMedicoResponse> {
        if (!params?.numeroProtocolo || !params?.anoProtocolo || !params?.ufCrm) {
            return throwError(() => new Error('Parâmetros inválidos: numeroProtocolo, anoProtocolo e ufCrm são obrigatórios.'));
        }

        return this.api.consultar(params, context);
    }

    atualizarDados(dto: PreMedicoDTO, context?: HttpContext): Observable<void> {
        return this.api.atualizarDados(dto, context);
    }

    atualizarCadastro(dto: PreMedicoDTO, context?: HttpContext): Observable<void> {
        if (!dto?.numeroProtocolo || !dto?.anoProtocolo || !dto?.uf) {
            return throwError(() => new Error('Parâmetros inválidos: numeroProtocolo, anoProtocolo e uf são obrigatórios.'));
        }

        return this.api.atualizarCadastro(dto, context);
    }

    visualizarAnexo(idAnexo: string, context?: HttpContext): Observable<Blob> {
        const id = idAnexo?.trim();
        if (!id) {
            return throwError(() => new Error('Id do anexo não informado.'));
        }

        return this.servicoAnexo.visualizarAnexo(id, context);
    }
}
